module.exports = __webpack_public_path__ + "static/media/laurel_gold_with_background.d5fda31e.svg";